import { appData } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section
      id="app"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/5 to-accent-500/5 rounded-2xl border border-background-300/40 p-8 md:p-12">
            {/* Left text */}
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-3">
                {appData.subtitle}
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-400 mt-3 leading-relaxed max-w-md mx-auto lg:mx-0">
                {appData.description}
              </p>

              {/* Features list */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-2 mt-5">
                {appData.features.map((feat) => (
                  <span
                    key={feat}
                    className="inline-flex items-center gap-1 text-xs text-foreground-300 bg-background-200/60 px-3 py-1.5 rounded-full"
                  >
                    <i className="ri-check-line text-primary-500"></i>
                    {feat}
                  </span>
                ))}
              </div>

              {/* Download buttons */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3 mt-6">
                <a
                  href={appData.iosLink}
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 hover:bg-foreground-100 text-background-950 font-medium rounded-full text-sm transition-colors"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  iOS 下载
                </a>
                <a
                  href={appData.androidLink}
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full text-sm transition-colors"
                >
                  <i className="ri-android-fill text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>

            {/* Right QR placeholder */}
            <div className="shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-background-200/70 rounded-2xl border border-background-300/40 flex flex-col items-center justify-center gap-2">
                <i className="ri-qr-code-line text-foreground-600 text-5xl md:text-6xl"></i>
                <span className="text-[10px] text-foreground-500">扫码下载APP</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}